import(/* webpackMode: "eager" */ "/codebuild/output/src821806899/src/faculdademetropolitana/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src821806899/src/faculdademetropolitana/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src821806899/src/faculdademetropolitana/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src821806899/src/faculdademetropolitana/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src821806899/src/faculdademetropolitana/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src821806899/src/faculdademetropolitana/node_modules/next/dist/client/script.js");
